module.exports = __webpack_public_path__ + "static/img/help-icon.7dcc73dc.png";